/**
 * TanStack Query hook for fetching Slide Sense folders.
 */

import { useQuery } from "@tanstack/react-query"

import type { SlideSenseFolder } from "../types"

import { fetchFolders } from "../api"

/**
 * Fetch all folders available to the current user.
 */
export function useFolders() {
  return useQuery<SlideSenseFolder[]>({
    queryKey: ["slide-sense", "folders"],
    queryFn: () => fetchFolders(),
  })
}
